import { ADJUST_CAROUSEL_TOP_HEIGHT } from 'actions';
import { CarouselReduxReducer } from 'typings';

export function adjustCarouselTopHeight(
  reduxReducer: CarouselReduxReducer,
  heightDelta: number,
) {
  return { heightDelta, reduxReducer, type: ADJUST_CAROUSEL_TOP_HEIGHT };
}
